import { get } from 'lodash';
import React, { FC } from 'react';
import Roman from 'roman-numerals';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { FOERDERPROGRAMM_ABSCHLUSS_TEXTE_VN_PATHS } from 'src/lib/constants/componentsPath';
import { ABSCHLUSS_HINWEISE_TABS } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import VNAngabenPruefen from './content/VNAngabenPruefen';
import VNEinreichen, { getFormStrucAbschlussVN } from './content/VNEinreichen';
import VNHerunterladen from './content/VNHerunterladen';

// import schemas
import FoerderProgrammSchema from 'src/lib/paths/foerderprogramm_FULL_Paths.json';
import VerwendungNachweisSchema from 'src/lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = VerwendungNachweisSchema.attributes;
const FP_P = FoerderProgrammSchema.attributes;

export const VNTreeStructureAbschluss = (application: any) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Mittelabruf und Verwendungsnachweis einreichen',
			content: <ApplicationHeading title='Mittelabruf und Verwendungsnachweis einreichen' description='' />,
			children: GetChildrenVNAbschluss(application),
		},
	];

	return treeNodes;
};

const GetChildrenVNAbschluss = (application: any) => {
	let children: TreeNodeType[] = [];

	const foerderProgramm = get(application, VN_P.Foerderantrag.schema.attributes.Foerderprogramm.path, {});

	const hinweisBlockSorted = sortAbschlussHinweisBlock(get(foerderProgramm, FP_P.Texte_Abschluss_Zum_Verwendungsnachweis.path, []));

	children = hinweisBlockSorted.map((ele: any, i: number) => {
		const tab = get(ele, FOERDERPROGRAMM_ABSCHLUSS_TEXTE_VN_PATHS.Tab, '');

		return {
			label: `${tab !== ABSCHLUSS_HINWEISE_TABS.Weitere ? Roman.toRoman(i + 1) + '. ' : ''} ${get(ele, FOERDERPROGRAMM_ABSCHLUSS_TEXTE_VN_PATHS.Titel, '')}`,
			content: <GetAbschlussContent eachHinweis={ele} tab={tab} />,
			formStruc:
				get(ele, FOERDERPROGRAMM_ABSCHLUSS_TEXTE_VN_PATHS.Tab) === ABSCHLUSS_HINWEISE_TABS.FoerderungBeantragen ? getFormStrucAbschlussVN() : [],
		};
	});

	return children;
};

const GetAbschlussContent: FC<{ eachHinweis: any; tab: string }> = ({ eachHinweis, tab }) => {
	const untertitel = get(eachHinweis, FOERDERPROGRAMM_ABSCHLUSS_TEXTE_VN_PATHS.UnterTitel, '');
	const inhalt = get(eachHinweis, FOERDERPROGRAMM_ABSCHLUSS_TEXTE_VN_PATHS.Inhalt, '');

	switch (tab) {
		case ABSCHLUSS_HINWEISE_TABS.AngabenPruefen:
			return <VNAngabenPruefen untertitel={untertitel} inhalt={inhalt} />;
		case ABSCHLUSS_HINWEISE_TABS.AntragHerunterladen:
			return <VNHerunterladen untertitel={untertitel} inhalt={inhalt} />;
		case ABSCHLUSS_HINWEISE_TABS.FoerderungBeantragen:
			return <VNEinreichen untertitel={untertitel} inhalt={inhalt} />;
		default:
			return <VNAbschlussWeitere untertitel={untertitel} inhalt={inhalt} />;
	}
};

function sortAbschlussHinweisBlock(hinweisArray: any[]) {
	const tabOrder = Object.values(ABSCHLUSS_HINWEISE_TABS).filter((tab) => tab !== 'Weitere');

	// "Gültige" Hinweise nach tabOrder sortieren
	const andereHinweise = hinweisArray.filter((item) => item.Tab && item.Tab !== 'Weitere');
	const weitereHinweise = hinweisArray.filter((item) => !item.Tab || item.Tab === 'Weitere');

	const sortierteAndereHinweise = tabOrder.map((tab) => andereHinweise.find((item) => item.Tab === tab)).filter(Boolean);

	return [...sortierteAndereHinweise, ...weitereHinweise];
}

const VNAbschlussWeitere: FC<{ untertitel: string; inhalt: string }> = ({ untertitel, inhalt }) => {
	return (
		<>
			<ApplicationHeading title={untertitel} />
			<MarkdownRenderer markdown={inhalt} />
		</>
	);
};
